export const UserLoggedIn = () => 'userLoggedIn'
export const UserSignedUp = () => 'userSignedUp'
